define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function riqChildFormStateDecoratorsModule(aoflModules) {
  'use strict';
  // var storeService = aoflModules.store;
  var objectUtils = aoflModules.objectUtils;
  var gradeIconMapping = {
    576: {icon: 'pre-readers.png'},
    577: {icon: 'preschool.png'},
    578: {icon: 'kindergarten.png'},
    579: {icon: 'first_grade.png'},
    580: {icon: 'second_grade.png'},
    581: {icon: 'third_grade.png'},
    582: {icon: 'fourth_grade.png'},
    583: {icon: 'fifth_grade.png'},
    584: {icon: 'sixth_grade.png'}
  };

  var decorators = function decorators() {
    return function riqChildFormDecorators(namespace) {
      return [
        function gradeLevelDecorator(_nextState) {
          var nextState = _nextState;
          var levels = nextState[namespace].levels;
          if (Array.isArray(levels) && levels.length > 1) {
            var decoratedLevels = levels.map(function(level) {
              if (
                !level.hasOwnProperty('gradeLabel') ||
                !level.hasOwnProperty('id')
              ) {
                var label = level.label;
                var splitLabel = label.split(/\r\n|\n|\r/);
                return Object.assign({}, level, {
                  gradeLabel: splitLabel[0],
                  id: level.tagId,
                  icon: gradeIconMapping[level.tagId].icon
                });
              }
              return level;
            });
            return objectUtils.deepAssign(_nextState, namespace, {
              levels: decoratedLevels
            });
          }
          return nextState;
        }
      ];
    };
  };

  return decorators;
});
